// Toggles one call-agenda talking point. A plain fetch PATCH (not button_to)
// because the agenda checklist sits inside the discovery questionnaire form —
// a nested <form> would be invalid HTML. The server responds with a Turbo
// Stream that re-renders just that section's agenda card.
import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { url: String };

  async toggle() {
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: "text/vnd.turbo-stream.html",
      },
    });
    if (response.ok) {
      Turbo.renderStreamMessage(await response.text());
    }
  }
}
